/** @format */

import { git } from './git'
import { html } from './html'
import { js } from './js'
import { react } from './react'
import { redux } from './redux'

export const developMenu = { html, js, react, redux, git }
